import { Box } from '@mui/material';
import { rowStyles } from '@/components/content/HdmSkucomparer/styles';

export const Row = ({ children }: { children: React.ReactNode }) => (
	<Box sx={rowStyles.container}>{children}</Box>
);
